<div
  class="tab-wrapper settings-page"
  [ngClass]="{
    mobile: (isMobile$ | async),
    tablet: (isTablet$ | async),
    medium: (isMedium$ | async)
  }"
>
  <div class="dashboard-card d-card-padding">
    <h4 class="sub-title bold mb-1">{{ 'WM_TECH_POOL.SETTINGS.PROFILE_INFO' | translate }}</h4>

    <app-profile-info></app-profile-info>
  </div>

  <div class="dashboard-card d-card-padding">
    <h4 class="sub-title bold mb-1">{{ 'WM_TECH_POOL.SETTINGS.CHANGE_PASSWORD' | translate }}</h4>

    <app-change-password></app-change-password>
  </div>

  <div class="dashboard-card d-card-padding">
    <h4 class="sub-title bold mb-1">{{ 'WM_TECH_POOL.SETTINGS.TFA' | translate }}</h4>

    <app-toggle-tfa></app-toggle-tfa>
  </div>

  <div class="dashboard-card d-card-padding active_sesstions">
    <h4 class="sub-title bold mb-1">{{ 'WM_TECH_POOL.SETTINGS.ACTIVE_SESSIONS' | translate }}</h4>

    <ng-container *ngIf="activeSessionsLoaded === true; else activeSessionsLoading">
      <app-active-sessions *ngIf="activeSessions" [activeSessions]="activeSessions"></app-active-sessions>
    </ng-container>
    <ng-template #activeSessionsLoading>
      <div class="wm-loading" style="height: 260px"></div>
    </ng-template>
  </div>
</div>
